import { Trash } from "lucide-react"
import { HTMLAttributes } from "react"

import { Button } from "../../../../components/base/control/Button"
import { LucideIconComponent } from "../LucideIcon"
import { LucideIconProps, IconSizes } from "../LucideIcon/LucideIcon"

interface FilterHeaderRowProps {
  label: string
  onClickDelete: () => void
}

export function FilterHeaderRow({
  label,
  onClickDelete,
}: FilterHeaderRowProps) {
  return (
    <div className="flex flex-row justify-between px-3 pt-2">
      <div className="flex flex-row items-center gap-2">
        <span>{label}</span>
      </div>
      <IconButton
        onClick={onClickDelete}
        Icon={Trash}
        wrapperSize={IconSizes.ExtraLarge}
        iconSize={IconSizes.Small}
      />
    </div>
  )
}

type IconButtonProps = Pick<
  LucideIconProps,
  "Icon" | "iconSize" | "wrapperSize"
> &
  HTMLAttributes<HTMLButtonElement>

export function IconButton({
  Icon,
  iconSize,
  wrapperSize,
  ...otherProps
}: IconButtonProps) {
  return (
    <Button
      mode="ghost"
      className="color-subtle rounded-full p-0"
      size="small"
      {...otherProps}
    >
      <LucideIconComponent
        Icon={Icon}
        iconSize={iconSize}
        wrapperSize={wrapperSize}
      />
    </Button>
  )
}
